import * as React from 'react';
import { AppContext, AppContextType } from '../AppContextType';
import { Product } from '../Model/Product';

export interface TransProps {
    id?: string
    arguments?: any[]
}

export class Trans extends React.PureComponent<TransProps> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    public render() {
        const i18n = this.context.i18n;
        const props = this.props;
        const children = props.children;
        const args = props.arguments || [];
        if (props.id && i18n.hasTranslation(props.id)) {
            return this.prepareText(i18n.translate(props.id, args));
        } else if (typeof children === 'string') {
            return this.prepareText(i18n.translate(children, args));
        } else {
            console.error('Children are not of type string');

            return null;
        }
    }

    private prepareText(s: string): string {
        return s.replace(/&shy;/g, '\u00AD');
    }
}
